import React from "react";

class PaymentSuccess extends React.Component {
  render() {
    return (
      <div style={{ padding: 80, textAlign: "center" }}>
        <h1>✅ Payment Successful</h1>
        <p>Your booking is confirmed.</p>
      </div>
    );
  }
}

export default PaymentSuccess;
